import React, { useState, useEffect } from "react";
import axios from 'axios';
import Swal from "sweetalert2";
import dayjs from 'dayjs';
import 'dayjs/locale/id';
import 'dayjs/locale/en';
import { useTranslation } from 'react-i18next';
import { useCookies } from 'react-cookie';
import BeritaOverlayCard from "../BeritaOverlayCard";

const ITEMS_PER_PAGE = 4;

const News = () => {
	const [cookies] = useCookies(['i18next']);
	const [posts, setPosts] = useState([]);
	const [currentPage, setCurrentPage] = useState(1);
	const { t } = useTranslation();

	const formatDate = (date, locale = 'en') => {
		dayjs.locale(locale);
		return dayjs(date).format('DD MMMM YYYY');
	};

	useEffect(() => {
		const fetchPosts = async () => {
			try {
				const url = process.env.REACT_APP_API_URL;
				const endpoint = process.env.REACT_APP_API_POST;
				const response = await axios.get(`${url}${endpoint}`);
				setPosts(response.data);
			} catch (err) {
				Swal.fire({
					icon: "error",
					title: "Oops...",
					text: err,
				});
			}
		};
		fetchPosts();
	}, []);

	const convertToSlug = (title) => {
		return title
			.toLowerCase()
			.trim()
			.replace(/[^\w\s-]/g, '')
			.replace(/\s+/g, '-')
			.replace(/-+/g, '-');
	};

	const totalPages = Math.ceil(posts.length / ITEMS_PER_PAGE);
	const currentPosts = posts.slice(
		(currentPage - 1) * ITEMS_PER_PAGE,
		currentPage * ITEMS_PER_PAGE
	);

	const getPageNumbers = () => {
		if (totalPages <= 5) {
			return Array.from({ length: totalPages }, (_, i) => i + 1);
		}
		if (currentPage <= 2) {
			return [1, 2, 3, '...', totalPages];
		}
		if (currentPage >= totalPages - 1) {
			return [1, '...', totalPages - 2, totalPages - 1, totalPages];
		}
		return [1, '...', currentPage, '...', totalPages];
	};

	const handlePageChange = (page) => {
		setCurrentPage(page);
		document.querySelector('.news-section')?.scrollIntoView({ behavior: 'smooth' });
	};

	return (
		<section className="news-section">
			<div className="portfolio-content conatainer-fluid">
				<div className="container">
					<div className="blog-box">
						<div className="section-title-box text-center">
							<h2 className="section-title" style={{ color: '#146AA4' }}>
								{t('menu.beritaKegiatan')}
							</h2>
						</div>
					</div>

					<div className="row">
						{posts.length > 0 ? (
							currentPosts.map((item) => (
								<div
									className="col-md-6 col-lg-6 mb-4"
									data-aos="fade-up"
									data-aos-anchor-placement="bottom-bottom"
									key={item.id}
								>
									<BeritaOverlayCard
										item={item}
										href={`/berita-terkait/${btoa(item.id)}/${convertToSlug(item.title)}`}
									/>
								</div>
							))
						) : (
							<p className="text-center">No posts available.</p>
						)}
					</div>

					{totalPages > 1 && (
						<div className="pagination">
							<button
								className="pagination-btn"
								onClick={() => handlePageChange(currentPage - 1)}
								disabled={currentPage === 1}
							>
								&laquo;
							</button>

							{getPageNumbers().map((page, idx) =>
								page === '...' ? (
									<span
										key={`ellipsis-${idx}`}
										style={{ padding: '6px 4px', color: '#888', fontSize: '14px' }}
									>
										...
									</span>
								) : (
									<button
										key={page}
										className={`pagination-btn ${currentPage === page ? 'active' : ''}`}
										onClick={() => handlePageChange(page)}
									>
										{page}
									</button>
								)
							)}

							<button
								className="pagination-btn"
								onClick={() => handlePageChange(currentPage + 1)}
								disabled={currentPage === totalPages}
							>
								&raquo;
							</button>
						</div>
					)}

				</div>
			</div>
		</section>
	);
};

export default News;
